export const LOAN_TYPE_GIVEN = 1;

export const LOAN_TYPE_LABELS = {
  1: "Given",
};

export const getLoanTypeLabel = (row) => {
  if (!row) return "";
  if (row.loan_type_label) return row.loan_type_label;
  return LOAN_TYPE_LABELS[Number(row.loanType)] || "Given";
};

export const getLoanBalance = (row) => {
  if (!row) return 0;
  if (row.balance != null) return Number(row.balance);
  const disbursed = Number(row.totalDisbursed ?? row.amount ?? 0);
  const repaid = Number(row.totalRepaid ?? row.paidAmount ?? 0);
  return Math.max(0, disbursed - repaid);
};

export const getLoanPrincipal = (row) =>
  Number(row?.totalDisbursed ?? row?.amount ?? 0);

export const getLoanPaid = (row) =>
  Number(row?.totalRepaid ?? row?.paidAmount ?? 0);

export const getLoanStatusLabel = (row) => {
  if (!row) return "";
  if (row.status === "settled") return "Settled";
  if (row.status === "partial") return "Partial";
  return "Open";
};

const sortLoanLogChronological = (a, b) => {
  if (a.date !== b.date) return a.date - b.date;
  if (a.entryType !== b.entryType) {
    return a.entryType === "disbursement" ? -1 : 1;
  }
  return String(a._id).localeCompare(String(b._id));
};

/** Running balance (disbursed − repaid) after each entry, keyed by entry _id. */
export const computeLoanRunningBalances = (entries, { perAccount = false } = {}) => {
  const map = new Map();
  const rows = Array.isArray(entries) ? entries : [];

  const runForGroup = (groupRows) => {
    let running = 0;
    [...groupRows]
      .filter((row) => row.isDeleted !== true)
      .sort(sortLoanLogChronological)
      .forEach((row) => {
        const amount = Number(row.amount || 0);
        if (row.entryType === "disbursement") running += amount;
        else running -= amount;
        map.set(row._id, Math.max(0, running));
      });
  };

  if (!perAccount) {
    runForGroup(rows);
    return map;
  }

  const byAccount = new Map();
  rows.forEach((row) => {
    const key = String(row.loanAccountId || "_");
    if (!byAccount.has(key)) byAccount.set(key, []);
    byAccount.get(key).push(row);
  });
  byAccount.forEach(runForGroup);
  return map;
};

export const withLoanRunningBalances = (entries, options) => {
  const balanceMap = computeLoanRunningBalances(entries, options);
  return (entries || []).map((row) => ({
    ...row,
    balanceAfter: balanceMap.get(row._id) ?? 0,
  }));
};
